import { Button } from "components"
import { TabRegister , TabProps } from "../types"

export function TabNavRegister({ activeTab, setActiveTab }: TabProps) {

  const tabs: TabRegister[] = [
    { label: "BY DATE RANGE", path: "date-range", permission: "IR01" },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto sticky top-[60px] z-[1]">
      {tabs.map((tab) => (
        <Button
          key={tab.path}
          permission={tab?.permission}
          type="button"
          color="ghost"
          size="sm"
          className={`grow bg-[#3c3c3c] border-y-0 border-x no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
